<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">Contact</strong>
      </div>
      <ContactDialog :account="account" />
    </template>

    <Item icon="mdi-domain">{{ account.account_name }}</Item>
    <Item icon="mdi-web">{{ account_url }}</Item>
  </Section>
</template>

<script>
  import { Section, Item } from '@/components/pages'
  import ContactDialog from '../dialogs/Contact.vue'

  export default {
    name: 'AccountContactSection',

    components: { ContactDialog, Section, Item },

    props: ['account'],

    computed: {
      account_url() {
        return window.location.origin
      },
    },
  }
</script>